"use strict";

exports.__esModule = true;
exports.default = mapComponentThemes;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * Generates a new component theme based on the theme of another component.
 *
 * preserveKeys
 *
 *   What does it do:
 *
 *     Ensures source theme variables are used in override styles when the
 *     source does not apply those styles and the override component is
 *     independently themeable
 *
 *     e.g. Necessary in TableHeaderCell (which is a themed TableCell) because
 *     TableCells and TableHeaderCells are both independently themeable
 *
 *   How to use:
 *
 *     Provide array of theme variable keys used in style properties applied by
 *     source component and not by override component
 */


function mapComponentThemes(source, override, baseTheme, preserveKeys) {
  var REGEXP_SOURCE_NAME = new RegExp("^" + source.name);
  var sourceThemeWithRenamedKeys = Object.keys(source.theme).reduce(function (acc, sourceKey) {
    if (REGEXP_SOURCE_NAME.test(sourceKey)) {
      var overrideKey = sourceKey.replace(REGEXP_SOURCE_NAME, override.name);
      acc[overrideKey] = source.theme[sourceKey];
    }

    return acc;
  }, {});
  var preserved = preserveKeys && preserveKeys.reduce(function (acc, sourceKey) {
    var keyProperty = sourceKey.split('_')[1];
    acc[override.name + "_" + keyProperty] = source.theme[sourceKey];
    return acc;
  }, {});
  return _objectSpread({}, sourceThemeWithRenamedKeys, override.theme, baseTheme, preserved);
}